import { MdHomeFilled } from "react-icons/md";
import { TitleSection } from "../components";
import NewsScreen from "../components/news-screen";
import { DefaultLayout } from "../layouts";

export default function NewsPage() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "News", link: "#" },
  ];

  return (
    <DefaultLayout footerVariant="light">
      <TitleSection
        title="News"
        bg="/images/news-and-blogs-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <NewsScreen />
    </DefaultLayout>
  );
}
